<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="submit" id="add_file_form">
                <kt-row>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="document_type">
                                {{ $t('pos.document_type') }}
                            </kt-form-label>
                            <select
                                    id="document_type"
                                    name="document_type_id"
                                    v-model="form_data.document_type_id"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-for="(value,index) in customer_data.document_types"
                                        :value="index"
                                >
                                    {{ value }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="image">
                                {{ $t('pos.document_pic') }}
                            </kt-form-label>
                            <kt-form-label for="image" class="d-block btn btn-secondary btn-wide label-file">
                                <kt-icon type="fa" name="paperclip"></kt-icon>
                                {{ $t('pos.click_me') }}
                            </kt-form-label>
                            <input
                                    @change="processFile"
                                    type="file"
                                    id="image"
                                    name="image"
                                    class="custom-file-upload"
                                    accept=".jpg,.jpeg,image/png"
                            />
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-form-action class="mt-4">
                    <kt-button
                            class="m-2"
                            size="md"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="submit_btn"
                    >
                        {{ $t('panel.profile.update.wizard.form.btn.submit') }}
                    </kt-button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>


import toastr from "toastr";
import {mapGetters} from "vuex";
import {i18n} from '@/plugins/i18n'
import $ from "jquery";

export default {
    props: {
        submit: {
            default: () => {
                return {}
            },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        },
        customer_data: [],
    },
    data() {
        return {}
    },
    components: {},
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.afterDispatch()
    },

    methods: {
        processFile(e) {
            this.form_data.image = event.target.files[0]
        },
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }) ,2000)


        },
    }
}
</script>

<style scoped>

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>